import PageOrPost, { getStaticProps as _getStaticProps } from './[slug]'

export async function getStaticProps(ctx) {
    return _getStaticProps({ ...ctx, params: { slug: "/" } });
}

export default PageOrPost
